export const InviteStatus = {
    PENDING_APPROVAL: 'pending_approval',
    INVITED: 'invited',
    ACCEPTED: 'accepted',
    EXPIRED: 'expired',
    DELETED: 'deleted',
};